<template>
	<v-layout column>
		<v-layout>
			<v-flex sm12 md12>
				<v-combobox
					v-model="humanIdLocal"
					:items="humans"
					:label="labelHuman"
					item-text="name"
					return-object
					:error="!!errorHuman"
					:error-messages="errorHuman"
				>
					<template slot="selection" slot-scope="data" >
						<div
							:selected="data.selected"
							@input="data.parent.selectItem()"
						>
							<template v-if="typeof data.item !== 'object'">
								<span>{{getDefaultItem(data.item)}}</span>
							</template>
							<template v-else>
								<v-list-tile-content>
									<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
								</v-list-tile-content>
							</template>
						</div>
					</template>
				</v-combobox>
			</v-flex>
		</v-layout>
		<v-layout v-if="humanIdLocal">
			<v-flex sm12 md12>
				<v-combobox
					v-model="addressIdLocal"
					:items="listAddress"
					label="Address"
					item-text="cz_addr"
					return-object
				>
					<template slot="selection" slot-scope="data" >
						<div
							:selected="data.selected"
							@input="data.parent.selectItem()"
						>
							<template v-if="typeof data.item !== 'object'">
								<span>{{getDefaultItemAddress(data.item)}}</span>
							</template>
							<template v-else>
								<v-list-tile-content>
									<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
								</v-list-tile-content>
							</template>
						</div>
					</template>
				</v-combobox>
			</v-flex>
		</v-layout>
	</v-layout>
</template>
<script>
export default {
	props: {
		listHuman: {
			type: Array,
			default: []
		},
		listAddress: {
			type: Array,
			default: []
		},
		addressId: [String, Number],
		humanId: [String, Number],
		labelHuman: String,
		errorHuman: [String, Array]
	},
	watch: {
		humanId: function(prop, prevProp) {
			if (prop !== prevProp && prop) {
				this.$emit('getAddress', prop)
			}
		}
	},
	computed: {
		humanIdLocal: {
			get: function() {
				return this.humanId
			},
			set: function(val) {
				this.$emit('update:humanId', val.id)
			}
		},
		addressIdLocal: {
			get: function() {
				return this.addressId
			},
			set: function(val) {
				this.$emit('update:addressId', val.id)
			}
		},
		humans() {
			let list = this.listHuman
			if (this.listHuman.length > 0 && this.listHuman[0].hasOwnProperty('landlord_name')) {
				return this.listHuman.map(item => {
					return { ...item, name: item.landlord_name }
				})
			}
			return list
		}
	},
	methods: {
		getDefaultItem(itemId) {
			const item = this.humans.find(
				({ id }) => parseInt(itemId) === parseInt(id)
			)
			if (!item) return ''
			return item.name
		},
		getDefaultItemAddress(itemId) {
			const item = this.listAddress.find(
				({ id }) => parseInt(itemId) === parseInt(id)
			)
			if (!item) return ''
			return item.cz_addr
		}
	}
}
</script>
